


































































import Vue from "vue";

import permission, { PermissionName } from "@/common/mixins/permission";
import pagination, { PaginationForm } from "@/common/mixins/pagination";
import dialog from "@/common/mixins/dialog";
import { Role } from "../models/Role";

export default Vue.extend({
  mixins: [pagination, permission, dialog],
  data() {
    const roles: Role[] = [];

    return { roles };
  },
  computed: {
    hasRoleCreatePermission() {
      return (this as any).hasPermission(PermissionName.ROLE_CREATE);
    }
  },
  async created() {
    (this as any).getPaginationRouteQuery();

    await Promise.all([this.getRoles()]);
  },
  watch: {
    async "$route.query"() {
      await this.getRoles();
    }
  },
  methods: {
    async getRoles() {
      const form: PaginationForm = {
        page: (this as any).currentPage,
        perPage: (this as any).perPage
      };

      try {
        const { data, meta } = await (this as any).$dep.roleUseCase.getRoles(
          form
        );

        this.roles = data;
        (this as any).setPaginationMeta(meta);
      } catch (error) {
        console.log(error.response);
      }
    },
    goToRoleCreatePage() {
      this.$router.push({ name: "RoleCreatePage" });
    },
    goToRoleUpdatePage(id: any) {
      this.$router.push({ name: "RoleEditPage", params: { id } });
    },
    async deleteRole(id: number) {
      try {
        await (this as any).$dep.roleUseCase.deleteRole(id);
        (this as any).alertSuccess("Success", "ลบ Role สำเร็จ");
        this.getRoles();
      } catch (error) {
        if (error.response && error.response.status === 400) {
          (this as any).alertError("Error", error.response.data.message);
        } else {
          process.env.NODE_ENV === "production"
            ? (this as any).alertError("Error", "ไม่สามารถลบ Role นี้")
            : (this as any).alertError("Error", error);
        }
      }
    },
    async deleteRoleDialog(role: Role) {
      const isComfirmed = await (this as any).alertConfirm(
        "ลบ Role",
        `คุณต้องการที่จะลบ Role ${role.name} ใช่ไหม?`
      );
      if (isComfirmed) {
        this.deleteRole(role.id);
      }
    }
  }
});
